module.exports = __webpack_public_path__ + "img/leavedates-logo.c3e24b00.svg";